import { useContext } from "react";
import { Col, Image, Row, Container, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "./ThemeContext";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import SessionUtil from "../util/SessionUtil";

function AuthComp({ children, ...props }) {
  const { t } = useTranslation(); // Use t instead of lang
  const lang = sessionStorage.getItem("lang") || "en";
  const userType = SessionUtil.getTypeUser()
  const { theme } = useContext(ThemeContext);
  const arrowBack = props.arrowBack;
  const handleClickBack = () => {
    props.type !== 'OTP' && props.setType(props.isStore ? "3" : "selectUser");
    props.isStore && props.setIsStore(false);
    props.page !== "login" && props?.setTypeStore("0");
    if (props.type === 'OTP') {
        if (props.typeOTP === 'email') {
            props.setType(userType)
        } else if (props.typeOTP === 'OTPInput') {
            props.setTypeOTP('email')
        } else if (props.typeOTP === 'CreatePassword') {
            props.setTypeOTP('OTPInput')
        }
    }
  };
  return (
    <Container className="min-h-100vh d-flex justify-content-center align-items-center h-100">
      <Row className="justify-content-center g-0 py-5 w-100">
        <Col md={6} lg={5} className="d-none d-md-block bg-auth-comp">
          <Image
            alt="image"
            src="/images/bg-login.png"
            className="img-fluid img-auth"
          />
        </Col>
        <Col
          md={6}
          lg={5}
          className={`border-se-ee-round px-4 ${
            theme === "light" && "bg-white"
          }`}
        >
          <Row className="justify-content-center align-items-center h-100 py-4 px-lg-5">
            <Col xs={12}>
              {arrowBack && props.type !== "selectUser" && (
                <Button
                  aria-label="Aria label"
                  className="btn-transparent p-0 position-absolute"
                  onClick={handleClickBack}
                >
                  {lang === "en" ? (
                    <IoMdArrowRoundBack size={20} />
                  ) : (
                    <IoMdArrowRoundForward size={20} />
                  )}
                </Button>
              )}

              <div className="text-center pb-5">
                <Image
                  alt="image"
                  src="/images/logo.png"
                  className="img-fluid"
                />
              </div>
              {props.type !== "OTP" && (
                <>
                  <div className="d-flex align-items-center gap-2">
                    <p className="title-login mb-0">
                      {props.page === "login" &&
                        (props.type === "selectUser"
                          ? t("Select account type to Login")
                          : props.type === "1"
                          ? t("Login to operation account")
                          : props.type === "2"
                          ? t("Login to finance account")
                          : props.type === "3"
                          ? t("Login to store account")
                          : t("Login to admin account"))}
                      {props.page === "register" &&
                        (props.type === "selectUser"
                          ? t("Select account type to create")
                          : props.type === "1"
                          ? t("Create Operation account")
                          : props.type === "2"
                          ? t("Create finance account")
                          : props.type === "3"
                          ? t("Create Store account")
                          : t("Create admin account"))}
                      {props.page === "LinkDriver" &&
                        t("Link driver with operation") + " !"}
                    </p>
                    {props.page !== "" &&
                      props.page !== "LinkDriver" &&
                      props.page !== "profile" && (
                        <Image
                          alt="image"
                          src={
                            props.page === "login"
                              ? "/images/hand.png"
                              : props.page === "register"
                              ? "/images/rocket.png"
                              : ""
                          }
                          className="img-fluid"
                        />
                      )}
                  </div>
                  {props.page !== "profile" && props.page !== "" && (
                    <p className="font-13">{t("GetAllYourLovedFoods")}</p>
                  )}
                </>
              )}
              <div>{children}</div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default AuthComp;
